import React from 'react';
import { Headphones } from 'lucide-react';

interface MonitoringIndicatorProps {
  isMonitoring: boolean;
}

const MonitoringIndicator: React.FC<MonitoringIndicatorProps> = ({ isMonitoring }) => {
  if (!isMonitoring) return null;

  return (
    <div className="fixed bottom-24 right-4 bg-green-500/20 border border-green-500/50 rounded-lg px-3 py-2 flex items-center gap-2 animate-pulse z-50">
      <Headphones className="h-4 w-4 text-green-400" />
      <span className="text-sm text-green-400 font-medium">Monitoring Active</span>
    </div>
  );
};

export default MonitoringIndicator;
